"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["InputProps", "classes", "ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles() {
  return {
    container: {
      flexGrow: 1,
      position: 'relative'
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      left: 0,
      right: 0,
      zIndex: 10
    },
    suggestion: {
      display: 'block'
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    }
  };
};

var TextAutocomplete = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TextAutocomplete, _React$Component);

  var _super = _createSuper(TextAutocomplete);

  function TextAutocomplete(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextAutocomplete);
    _this = _super.call(this, props);
    _this.state = {
      inputValue: _this.props.inputValue,
      isInputFocused: false
    };
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.getItemValue = _this.getItemValue.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputFocus = _this.handleInputFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderInput = _this.renderInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.shouldRenderSuggestions = _this.shouldRenderSuggestions.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TextAutocomplete, [{
    key: "renderInput",
    value: function renderInput(inputProps) {
      var InputProps = inputProps.InputProps,
          classes = inputProps.classes,
          ref = inputProps.ref,
          other = (0, _objectWithoutProperties2.default)(inputProps, _excluded);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, _objectSpread(_objectSpread({}, other), {}, {
        inputRef: ref,
        disabled: this.props.disabled,
        multiline: this.props.multiline,
        InputProps: _objectSpread({
          classes: {
            input: classes.input
          }
        }, InputProps)
      }));
    }
  }, {
    key: "shouldRenderSuggestions",
    value: function shouldRenderSuggestions(value) {
      return value.trim().length >= this.props.minimumCharsToRenderResults;
    }
  }, {
    key: "renderMenuItem",
    value: function renderMenuItem(item) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        component: "div",
        children: item.menuContent
      });
    }
  }, {
    key: "renderMenuItemsContainer",
    value: function renderMenuItemsContainer(options) {
      var containerProps = options.containerProps,
          children = options.children;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, _objectSpread(_objectSpread({}, containerProps), {}, {
        square: true,
        children: children
      }));
    }
  }, {
    key: "getItemValue",
    value: function getItemValue() {
      return this.state.inputValue;
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event, options) {
      this.props.onInputEvent(event);
      this.setState({
        inputValue: options.newValue
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(event, options) {
      var _this2 = this;

      this.props.onSelectFunction(event, options, function (result) {
        if (!result) {
          _this2.setState({
            inputValue: ''
          });

          if (_this2.props.showSelectedValueFunction) {
            _this2.setState({
              inputValue: _this2.props.showSelectedValueFunction(options.suggestion.data)
            });
          }
        }
      });
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      this.setState({
        isInputFocused: true
      });

      if (this.props.controlledInput) {
        this.setState({
          inputValue: ''
        });
      }
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      this.setState({
        isInputFocused: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var inputValue = this.props.controlledInput && !this.state.isInputFocused ? this.props.inputValue : this.state.inputValue;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAutosuggest.default, {
        theme: {
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        },
        renderInputComponent: this.renderInput,
        suggestions: this.props.items,
        shouldRenderSuggestions: this.shouldRenderSuggestions,
        onSuggestionsFetchRequested: this.props.onChangeFunction,
        onSuggestionsClearRequested: this.props.onClearFunction,
        onSuggestionSelected: this.handleSelect,
        getSuggestionValue: this.getItemValue,
        focusInputOnSuggestionClick: this.props.focusInputOnSuggestionClick,
        renderSuggestion: this.renderMenuItem,
        renderSuggestionsContainer: this.renderMenuItemsContainer,
        inputProps: {
          classes: classes,
          placeholder: this.props.placeholder,
          error: this.props.error,
          helperText: this.props.helperText,
          label: this.props.label,
          value: inputValue,
          onChange: this.handleInputChange,
          onBlur: this.handleInputBlur,
          onFocus: this.handleInputFocus,
          autoFocus: this.props.autoFocus,
          autoComplete: 'off'
        }
      });
    }
  }]);
  return TextAutocomplete;
}(_react.default.Component);

TextAutocomplete.defaultProps = {
  autoFocus: false,
  controlledInput: false,
  inputValue: '',
  focusInputOnSuggestionClick: true,
  disabled: false,
  minimumCharsToRenderResults: 3,
  placeholder: '',
  multiline: false
};
TextAutocomplete.propTypes = {
  classes: _propTypes.default.object.isRequired,
  items: _propTypes.default.array.isRequired,
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  placeholder: _propTypes.default.string.isRequired,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onChangeFunction: _propTypes.default.func.isRequired,
  onSelectFunction: _propTypes.default.func.isRequired,
  onClearFunction: _propTypes.default.func.isRequired,
  onInputEvent: _propTypes.default.func,
  showSelectedValueFunction: _propTypes.default.func,
  autoFocus: _propTypes.default.bool,
  controlledInput: _propTypes.default.bool,
  inputValue: _propTypes.default.string,
  focusInputOnSuggestionClick: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  minimumCharsToRenderResults: _propTypes.default.number,
  multiline: _propTypes.default.bool
};

var _default = (0, _styles.withStyles)(styles)(TextAutocomplete);

exports.default = _default;
//# sourceMappingURL=TextAutocomplete.js.map